import { render, staticRenderFns } from "./ModifiedByInfo.vue?vue&type=template&id=62ca5b3b&scoped=true&"
import script from "./ModifiedByInfo.vue?vue&type=script&lang=js&"
export * from "./ModifiedByInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModifiedByInfo.vue?vue&type=style&index=0&id=62ca5b3b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca5b3b",
  null
  
)

export default component.exports